<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 1.25251C10 0.138879 8.65358 -0.418836 7.86612 0.368623L4.11612 4.11862H2.50755C1.55643 4.11862 0.57588 4.67232 0.291087 5.70617C0.101225 6.3954 0 7.12069 0 7.86862C0 8.61656 0.101225 9.34185 0.291087 10.0311C0.57588 11.0649 1.55643 11.6186 2.50755 11.6186H4.11612L7.86612 15.3686C8.65358 16.1561 10 15.5984 10 14.4847V1.25251Z"
                :fill="color" 
            />
            <path
                d="M14.2364 2.12333C14.4805 1.87925 14.8762 1.87925 15.1203 2.12333C18.2933 5.29634 18.2933 10.4408 15.1203 13.6138C14.8762 13.8579 14.4805 13.8579 14.2364 13.6138C13.9923 13.3697 13.9923 12.974 14.2364 12.7299C16.9213 10.0451 16.9213 5.69206 14.2364 3.00721C13.9923 2.76313 13.9923 2.3674 14.2364 2.12333Z"
                :fill="color" 
            />
            <path
                d="M12.0269 4.3331C12.271 4.08903 12.6667 4.08903 12.9108 4.3331C14.8634 6.28573 14.8634 9.45155 12.9108 11.4042C12.6667 11.6482 12.271 11.6482 12.0269 11.4042C11.7829 11.1601 11.7829 10.7644 12.0269 10.5203C13.4914 9.05582 13.4914 6.68145 12.0269 5.21699C11.7829 4.97291 11.7829 4.57718 12.0269 4.3331Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgVolumeUp',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>